import styled from 'styled-components/macro'
import { StickyGridHeader } from 'src/components/Reusable/Grid/Grid.styles'
import palette from 'src/designSystem/variables/palette'
import { GridRow } from '../../../components/Reusable/Grid'

export const ControlsHeader = styled(StickyGridHeader)`
  min-width: 164px;
`

export const DocumentationHeader = styled(StickyGridHeader)`
  min-width: 152px;
`

export const FrameworksHeader = styled(StickyGridHeader)`
  min-width: 171px;
`

export const SpinnerContainer = styled.div`
  width: 100%;
  margin-top: 2em;
`

export const PoliciesGridLoadingContainer = styled.div`
  width: 100%;
  margin-top: 2em;
  grid-column: span 7;
`

export const StyledGridRow = styled(GridRow)<{
  $isNotApplicable?: boolean
}>`
  text-decoration: none;
  &:hover {
    text-decoration: none;
  }

  ${({ $isNotApplicable }) =>
    $isNotApplicable &&
    `
    > .grid-column {
      background-color: ${palette.neutral['50']};
    }
    &:hover {
      > .grid-column {
        background-color: ${palette.neutral['100']};
      }
    }
  `}
`

export const PolicyNotApplicableBadgeContainer = styled.div`
  background-color: ${palette.neutral[500]};
  color: white;
  border-radius: 4px;
  padding: 2px 4px;
  font-size: 12px;
  font-weight: 500;
  p {
    margin-top: 2px;
  }
`
